import { Button, Grid } from '@mui/material'
import React, { useState, useEffect } from 'react'
import Navbar from '../Component/Navbar'
import HeaderSetting from '../Component/HeaderSetting'
import SettingDrawer from '../Component/SettingDrawer'
import LayoutCondition from '../Component/LayoutCondition'
import { Warning } from '../Component/Icons'
import Typography from '@mui/material/Typography';
import Divider from '../Component/Divider'
import axios from 'axios'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { toast } from 'react-toastify'
import '../App.css'
import { useInputValues } from '../Context/InputValuesContext'
import CustomToast from '../Component/CustomToast/CustomToast'
import { accessibilityData, appointmentData, dateData, emialData, formErrorsData, matrixData, navigationData, numberData, otherData, paymentData, progressData, radioData, requiredData, reviewData, submitData, textareaData, uploadData, validateData } from '../Constant/FormWarnings'

const FormWarnings = () => {

  const [searchQuery, setSearchQuery] = useState('');
  const [requierdTitle, setRequierdTitle] = useState('ضروری')
  const [formTitle, setFormTitle] = useState('خطاهای فرم')
  const [validateTitle, setValidateTitle] = useState('اعتبار سنجی')
  const [textareaTitle, setTextareaTitle] = useState("محیط متنی")
  const [emailTitle, setEmailTitle] = useState("ایمیل")
  const [radioTitle, setRadioTitle] = useState('Radio / Checkbox / Dropdown')
  const [numberTitle, setNumberTitle] = useState('شماره')
  const [dateTitle, setDateTitle] = useState('تاریخ')
  const [uploadTitle, setUploadTitle] = useState('بارگذاری')
  const [matrixTitle, setMatrixTitle] = useState('ماتریس')
  const [appointmentTitle, setAppointmentTitle] = useState('وقت ملاقات')
  const [paymentTitle, setPaymentTitle] = useState('پرداخت')
  const [submitTitle, setSubmitTitle] = useState('دکمه ارسال')
  const [otherTitle, setOtherTitle] = useState('دیگر')
  const [progressTitle, setProgressTitle] = useState('متن های پیشرفت')
  const [reviewTitle, setReviewTitle] = useState('بررسی و ارسال')
  const [accessibilityTitle, setAccessibilityTitle] = useState('دسترسی')
  const [navigationTitle, setavigationTitle] = useState('پیمایش خطا')



  let FormId = localStorage.getItem('createFormId')



  const { inputValues, setInputValues } = useInputValues();

  const { handleReset } = useInputValues();


  // Initialize input values if they don't exist
  useEffect(() => {
    const allData = [
      ...requiredData,
      ...formErrorsData,
      ...validateData,
      ...textareaData,
      ...emialData,
      ...radioData,
      ...numberData,
      ...dateData,
      ...uploadData,
      ...matrixData,
      ...appointmentData,
      ...paymentData,
      ...submitData,
      ...otherData,
      ...progressData,
      ...reviewData,
      ...accessibilityData,
      ...navigationData
    ];

    const initialValues = {};
    allData.forEach(item => {
      initialValues[item.id] = item.inputTitle;
    });

    setInputValues(initialValues);
  }, []);

  const handleChange = (e, dataItem) => {
    const { value } = e.target;
    setInputValues(prev => ({
      ...prev,
      [dataItem.id]: value
    }));
  };

  const handleSearch = e => {
    setSearchQuery(e.target.value);
  };

  const prepareDataForServer = () => {
    if (!inputValues) return { formId: FormId, warnings: {} };

    const warnings = {};
    // Get all data arrays
    const allData = [
      ...requiredData,
      ...formErrorsData,
      ...validateData,
      ...textareaData,
      ...emialData,
      ...radioData,
      ...numberData,
      ...dateData,
      ...uploadData,
      ...matrixData,
      ...appointmentData,
      ...paymentData,
      ...submitData,
      ...otherData,
      ...progressData,
      ...reviewData,
      ...accessibilityData,
      ...navigationData
    ];

    // Create warnings object with all inputs
    allData.forEach(item => {
      const inputValue = inputValues[item.id];
      warnings[item.id] = {
        name: item.inputTitle,
        value: inputValue || item.inputTitle
      };
    });

    return {
      formId: FormId,
      warnings
    };
  };

  const handleSave = () => {
    const dataToSend = prepareDataForServer();
    
    axios.post('YOUR_SERVER_ENDPOINT', dataToSend)
      .then(response => {
        toast(<CustomToast message="تغییرات با موفقیت ذخیره شد" state={'success'} color={'#1A4D2E'} />);
      })
      .catch(error => {
        toast(<CustomToast message="ذخیره تغییرات ناموفق بود. لطفا چند لحظه دیگر مجددا تلاش کنید" state={'erorr'} />);
        console.error('Error sending data:', error);
      });
  };


  const handleResetValues = () => {
    if (!inputValues) return;
    
    setInputValues(prev => 
      Object.keys(prev).reduce((acc, key) => {
        acc[key] = prev[key];
        return acc;
      }, {})
    );
    toast(<CustomToast message="تنظیم مجدد انجام شد" state={'success'} color={'#DC6B19'} />);
  };


  const filteredData = [
    { title: requierdTitle, data: requiredData },
    { title: formTitle, data: formErrorsData },
    { title: validateTitle, data: validateData },
    { title: textareaTitle, data: textareaData },
    { title: emailTitle, data: emialData },
    { title: radioTitle, data: radioData },
    { title: numberTitle, data: numberData },
    { title: dateTitle, data: dateData },
    { title: uploadTitle, data: uploadData },
    { title: matrixTitle, data: matrixData },
    { title: appointmentTitle, data: appointmentData },
    { title: paymentTitle, data: paymentData },
    { title: submitTitle, data: submitData },
    { title: otherTitle, data: otherData },
    { title: progressTitle, data: progressData },
    { title: reviewTitle, data: reviewData },
    { title: accessibilityTitle, data: accessibilityData },
    { title: navigationTitle, data: navigationData },
  ].filter(item => item.title.toLowerCase().includes(searchQuery.toLowerCase()));



  return (
    <Grid bgcolor={"#f3f3fe"} >
      <Grid display={{ xs: "none", xxs: "block" }}>
        <Navbar state={true} active={2} />
      </Grid>
      <Grid display={{ xs: "block", xxs: "none" }}>
        <HeaderSetting
          title={"فرم هشدارها"}
          subTitle={"پیام های هشدار را تغییر دهید"}
          link={`/settings/general/${FormId}`}
        />
      </Grid>
      <Grid
        mt={{ xxs: "118px" }}
        position={"relative"}
        display={"flex"}
        alignItems={"flex-start"}
        justifyContent={"center"}
      >
        <Grid display={{ xs: "none", sm: "block" }}>
          <SettingDrawer isActive={1} />
        </Grid>
        <Grid display={{ xs: "none", xxs: "block", sm: "none" }}>
          <SettingDrawer isActive={1} />
        </Grid>
        <Grid
          className="main"
          position={"absolute"}
          left={{ xs: "10px", xxs: "20px" }}
          mx={"auto"}
          width={{ xs: "100%", xxs: "75%", sm: "80%", md: "65%" }}
          mt={{ xs: "0px", xxs: "80px" }}
          pr={{ xs: "30px", xxs: "60px" }}
          pl={{ xs: "10px", xxs: "20px" }}
        >
          <LayoutCondition
            title={"فرم هشدارها"}
            subTitle={"زمانی که شخصی فرم شما را پر می کند، ایمیلی دریافت کنید"}
            link={`/settings/general/${FormId}`}
            icon={<Warning />}
            color={"rgba(255,123,28,1)"}
          />
          <Grid>
            <Grid className='search' mb={'12px'}>
              <input
                placeholder='جستجو کردن'
                style={{
                  padding: '9px 15px',
                  borderRadius: '4px',
                  border: '1px solid #c5c5c5',
                  width: '100%',
                  backgroundColor: 'white',
                  color: '#564632',
                  fontSize: '14px',
                  lineHeight: '24px',
                  boxShadow: '0 2px 4px rgba(86,70,50,.1)',
                  outline: 0
                }}
                onChange={handleSearch}
              />
            </Grid>
            <Grid className='warnings' border={'1px solid rgb(222, 217, 211)'} bgcolor={'white'} mb={'14px'}>
              {filteredData.map((item, index) => (
                <Grid key={index}>
                  <Grid p={'30px'}>
                    <Typography variant="h5" color="#596066" fontWeight={700} mb={'8px'}>
                      {item.title}
                    </Typography>
                    {item.data.map((dataItem, dataIndex) => (
                      <Grid key={dataIndex} mb={dataIndex === item.data.length - 1 ? '0px' : '24px'}>
                        <Typography variant='h6' color={'#596066'} fontWeight={700} pb="4px">
                          {dataItem.inputTitle}
                        </Typography>
                        <input
                          className='input-with-overflow'
                          name={dataItem.inputTitle}
                          value={inputValues[dataItem.id] || dataItem.inputTitle}
                          onChange={(e) => handleChange(e, dataItem)}
                          style={{
                            padding: '9px 15px',
                            borderRadius: '4px',
                            border: '1px solid #c5c5c5',
                            width: '100%',
                            backgroundColor: 'white',
                            color: '#564632',
                            fontSize: '14px',
                            lineHeight: '24px',
                            boxShadow: '0 2px 4px rgba(86,70,50,.1)',
                            outline: 0,
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                  <Grid className='' width={'full'} bgcolor={'rgb(222, 217, 211)'} height={'1px'}></Grid>
                </Grid>
              ))}
            </Grid>
            <Grid className='buttons' display={'flex'} alignItems={'center'} justifyContent={'space-between'} mb={'32px'}>
              <Button onClick={handleSave} className='save' sx={{ bgcolor: '#5cab40', color: 'white', padding: '12px 17px', borderRadius: '4px', fontSize: '15px', cursor: 'pointer', boxShadow: '0 2px 4px rgba(86,70,50,.1)', '&:hover': { bgcolor: '#77c25c' } }}>ذخیره تغییرات</Button>
              <Button onClick={handleResetValues} className='reset' sx={{ bgcolor: '#9b8a73', color: 'white', padding: '12px 17px', borderRadius: '4px', fontSize: '15px', cursor: 'pointer', boxShadow: '0 2px 4px rgba(86,70,50,.1)', '&:hover': { bgcolor: '#b0a391' } }}>تنظیم مجدد</Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FormWarnings;